import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import css from "./index.module.css";
import { emptyMinimizerData, removeMinimizerData } from "../../actions/minimizeFloatter";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { addRedirectParam } from "@Helpers";
import { Box } from "@mui/material";
import IconComponent from "@CubeComponents/icons";
export function MinimizeFloatter() {
  const { t } = useTranslation();
  const [dropDownState, setDropDownState] = useState(false);
  const minimizeFloatterData = useSelector((state) => state.minimizeFloatterData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ref = useRef();

  const handler = (event) => {
    if (!ref.current?.contains(event.target)) {
      setDropDownState(false);
    }
  };

  useEffect(() => {
    handler();
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  const handleRemoveIcon = () => {
    dispatch(emptyMinimizerData());
  };

  const handleSelectItem = (event) => {
    const index = event.currentTarget.attributes["data-set"].value;
    const urlWithUpdatedRedirect = addRedirectParam({
      targetPath: new URL(minimizeFloatterData[index].path, globalThis.location.origin),
      redirectTo: globalThis.location,
    });
    navigate(urlWithUpdatedRedirect);
    dispatch(removeMinimizerData(minimizeFloatterData[index].index));
  };

  const removeSelectItem = (index) => {
    dispatch(removeMinimizerData(minimizeFloatterData[index].index));
  };

  const changeState = () => {
    setDropDownState((prevState) => !prevState);
  };

  return (
    <>
      {minimizeFloatterData.length ? (
        <div ref={ref} className={css.root}>
          {dropDownState ? (
            <div className={css.mainContainer}>
              <div className={css.header}>
                <span className={css.openFile}>{t("Open Files")}</span>
                <Box className={css.closeFile} onClick={handleRemoveIcon}>
                  <strong>{t("Close All")}</strong>
                </Box>
              </div>
              {minimizeFloatterData.map((props, index) => (
                <div key={index} className={`${css.flexRowStart} ${css.fileDetails}`}>
                  <div className={css.fileSideIcon}>
                    <IconComponent name="FileDWG" />
                  </div>
                  <Box className={css.fileDiv} onClick={handleSelectItem} data-set={index}>
                    <p className={css.fileName}>{props.text}</p>
                  </Box>
                  <div className={css.closeIconDiv}>
                    <IconComponent
                      name="close"
                      data-set={index}
                      onClick={() => removeSelectItem(index)}
                      className="h-2.5 w-2.5"
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          <IconComponent
            name="cube_img"
            className="h-13 w-13"
            onClick={changeState}
            parentContainerClass="relative float-end !p-0 !min-w-0 !rounded-none"
          />
        </div>
      ) : null}
    </>
  );
}

export default MinimizeFloatter;
